// SupportCards.js
import React from 'react';
import '../../../../assests/css/admin/Help&Support/SupportCards/SupportCards.css';

const SupportCards = ({ onCreateTicket, onStartChat, onViewDocs }) => {
  return (
    <div className="AdminHelp-cards-container">
      <div className="AdminHelp-card">
        <div className="AdminHelp-card-icon AdminHelp-icon-blue">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M5 12h14"/>
          </svg>
        </div>
        <h3 className="AdminHelp-card-title">Submit a Ticket</h3>
        <p className="AdminHelp-card-description">
          Report an issue or request a feature directly to our technical team.
        </p>
        <button className="AdminHelp-card-button" onClick={onCreateTicket}>
          Create Ticket
          <span className="AdminHelp-button-arrow">→</span>
        </button>
      </div>

      <div className="AdminHelp-card">
        <div className="AdminHelp-card-icon AdminHelp-icon-green">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <h3 className="AdminHelp-card-title">Live Chat</h3>
        <p className="AdminHelp-card-description">
          Connect with a support agent in real-time for immediate assistance.
        </p>
        <button className="AdminHelp-card-button" onClick={onStartChat}>
          Start Chat
          <span className="AdminHelp-button-arrow">→</span>
        </button>
      </div>

      <div className="AdminHelp-card">
        <div className="AdminHelp-card-icon AdminHelp-icon-purple">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
          </svg>
        </div>
        <h3 className="AdminHelp-card-title">Documentation</h3>
        <p className="AdminHelp-card-description">
          Browse detailed guides and API references for developers.
        </p>
        <button className="AdminHelp-card-button" onClick={onViewDocs}>
          View Docs
          <span className="AdminHelp-button-arrow">→</span>
        </button>
      </div>
    </div>
  );
};

export default SupportCards;